// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1Vc8i","notes":"Notes_notes__3ktQE","note":"Notes_note__BdYAE","markdown":"Notes_markdown__2-Y0B"};